<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="personnePhysique?.civilite"
                [label]="step4.getcivilite" [type]="'select'" [optionsWithCode]="optionsSelect"
                [typeSelect]="optionsSelectType" [name]="getUid() + '_SepAtt_civilite'">
</app-form-input>
<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="personnePhysique?.nom" [label]="step4.getnom"
    [type]="'text'" [rule]="rule + 'minSize_5|maxSize_255'" [errorMessage]="{'pattern' : 'ctr_1436'}"  [name]="getUid() + '_SepAtt_nom'">
</app-form-input>
<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="personnePhysique?.pren" [label]="step4.getpren"
    [type]="'text'" [rule]="rule + 'minSize_1|maxSize_50'" [errorMessage]="{'pattern' : 'ctr_1436'}"  [name]="getUid() + '_SepAtt_pren'">
</app-form-input>
<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="personnePhysique?.fonc" [label]="step4.getfonc"
    [type]="'text'" [rule]="rule + 'minSize_1|maxSize_100'" [errorMessage]="{'pattern' : 'ctr_1436'}"  [name]="getUid() + '_SepAtt_fonc'">
</app-form-input>
